import React from 'react'
import './footer.css'

const Footer = () => {
  return (
      <footer className="footer">
        <div className="footer__container container">
          <h1 className="footer__title">Reni </h1>

          <ul className="footer__list">
            <li>
              <a href="#about" className="footer__link">About</a>
            </li>

            <li>
              <a href="#portfolio" className="footer__link">Projects</a>
            </li>

            <li>
              <a href="#skills" className="footer__link">Skills</a>
            </li> 
          </ul> 

          <div className="footer__social">
            <a href="https://www.instagram.com/keysmissing" target="_blank" className="footer__social-link">
              <i class="bx bxl-instagram"></i>
            </a>
            <a href="https://www.linkedin.com/in/rvs1212/" target="_blank" className="footer__social-link">
              <i class="bx bxl-linkedin"></i>
            </a>
            <a href="https://github.com/rvs1212/" target="_blank" className="footer__social-link">
              <i class="bx bxl-github"></i>
            </a>
            
          </div>

          <span className="footer__copy"> &#169; 2025 RENI. All rights reserved. </span>




        </div>
      </footer>

  )
}

export default Footer